export default async function getBranded({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'branded');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
